export const currentOrganization = (state, getters, rootState, rootGetters) => {
  return rootGetters['entities/Organization'](state.currentOrganizationId);
};
